"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenMediaButton = void 0;
var _react = require("react");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _analytics = require("../analytics");
var _CloseButton = _interopRequireDefault(require("../CloseButton"));
var _LexusButton = _interopRequireDefault(require("../LexusButton"));
var _jsxRuntime = require("react/jsx-runtime");
const handleExitClick = function () {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    /* Safari */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    /* IE11 */
    document.msExitFullscreen();
  }
};
const handleButtonClick = function (_ref) {
  let {
    ref,
    setShouldBeInert,
    fireAnalytics
  } = _ref;
  return function () {
    const elem = ref.current;
    if (!elem) return;
    if (elem.requestFullscreen) {
      elem.requestFullscreen().catch(handleFullScreenCatch);
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen().catch(handleFullScreenCatch);
    }
    elem.querySelector("video").play().catch(handleFullScreenCatch);
    setShouldBeInert(false);
    fireAnalytics("view");
  };
};
const handlePlayStateChange = function (_ref2) {
  let {
    videoRef,
    fireAnalytics
  } = _ref2;
  return function () {
    const {
      current: video
    } = videoRef;
    if (!video) return;
    const playState = video.paused ? "paused" : "playing";
    const events = {
      paused: "pause",
      playing: "play"
    };
    const event = events[playState];
    if (event) fireAnalytics(event);
  };
};
const handleFullScreenCatch = function () {
  // Something went wrong when trying to enter fullscreen mode
};
const useFullScreenEffect = function (_ref3) {
  let {
    ref,
    setShouldBeInert,
    fireAnalytics
  } = _ref3;
  const effect = function (event) {
    if (!document.fullscreenElement && ref.current) {
      // The document is no longer in fullscreen mode, reset video
      const elem = ref.current.querySelector("video");
      elem.pause();
      elem.currentTime = 0;
      setShouldBeInert(true);
      fireAnalytics("close");
    } else {
      // The document has entered fullscreen mode
      // console.log("Fullscreen mode has been entered.");
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener("fullscreenchange", effect);
    return function () {
      document.removeEventListener("fullscreenchange", effect);
    };
  }, []);
};
const StyledOverlay = _styledComponents.default.div({
  height: 0,
  overflow: "hidden",
  position: "relative"
});
const StyledVideo = _styledComponents.default.video({
  width: "100dvw",
  height: "100dvh"
});
const StyledCloseButtonWrapper = _styledComponents.default.div({
  position: "absolute",
  top: "1rem",
  right: "1rem",
  zIndex: 1
});
const FullScreenMediaButton = function (props) {
  const {
    src,
    mobileSrc,
    tabletSrc,
    desktopSrc,
    ...rest
  } = props;
  const [shouldBeInert, setShouldBeInert] = (0, _react.useState)(true);
  const fireAnalytics = (0, _analytics.useAnalytics)("OverlayComponent");
  const ref = (0, _react.useRef)();
  const videoRef = (0, _react.useRef)();
  const playStateChangeHandler = handlePlayStateChange({
    videoRef,
    fireAnalytics: (0, _analytics.useAnalytics)("Video", {
      medium: "html5"
    })
  });

  // Specific <video> element built-in controls to omit/include
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/video#controlslist
  const controlsList = ["nodownload", "nofullscreen", "noremoteplayback", "noplaybackrate" // non-standard but works in Chrome
  ].join(" ");
  useFullScreenEffect({
    ref,
    setShouldBeInert,
    fireAnalytics
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LexusButton.default, {
      ...rest,
      onClick: handleButtonClick({
        ref,
        setShouldBeInert,
        fireAnalytics
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledOverlay, {
      ref: ref,
      inert: shouldBeInert ? "true" : undefined,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCloseButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseButton.default, {
          onClick: handleExitClick
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledVideo, {
        ref: videoRef,
        src: src,
        controls: true,
        controlsList: controlsList,
        disablePictureInPicture: true,
        disableRemotePlayback: true,
        onPlay: playStateChangeHandler,
        onPause: playStateChangeHandler,
        children: [desktopSrc ? /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: desktopSrc,
          media: "(min-width: 1800px)"
        }) : null, tabletSrc ? /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: tabletSrc,
          media: "(min-width: 1000px)"
        }) : null, mobileSrc ? /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: mobileSrc
        }) : null]
      })]
    })]
  });
};
exports.FullScreenMediaButton = FullScreenMediaButton;